/**
 * @group Functions
 * 
 * @summary
 * <blockquote>Analyzes application errors and creates standardized AppError objects</blockquote>
 * 
 * @param {string} errorMessage - The error message to display
 * @param {string} details - Detailed description of the error
 * @param {string} code - Error code for programmatic handling
 * @returns {AppError} Structured application error object
 * 
 * @example
 * ```typescript
 * const error = analyzeApplicationError(
 *   'User not found',
 *   'The requested user does not exist in the system',
 *   'USER_NOT_FOUND'
 * );
 * ```
 */
import type { AppError } from '../../error/types/AppError';

export function analyzeApplicationError(
  errorMessage: string,
  details: string,
  code: string
): AppError {
  return {
    errorCode: code,
    errorMessage: errorMessage
  };
} 